import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  isLoading: true,
  user: null,
  userId: null,
  authToken: null,
  activePortal: "talent",
  roles: []
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginUser: (state, action) => {
      const { user, userId, authToken, activePortal, roles } = action.payload;
      state.isAuthenticated = true;
      state.isLoading = false;
      state.user = user;
      state.userId = userId;
      state.authToken = authToken;
      state.activePortal = activePortal;
      state.roles = roles;
    },
    logoutUser: (state) => {
      state.isAuthenticated = false;
      state.isLoading = false;
      state.user = null;
      state.userId = null;
      state.authToken = null;
      state.activePortal = "talent";
      state.roles = [];
    },
    initializeAuth: (state, action) => {
      const { isAuthenticated, user, userId, authToken, activePortal, roles } = action.payload;
      state.isAuthenticated = isAuthenticated;
      state.isLoading = false;
      state.user = user;
      state.userId = userId;
      state.authToken = authToken;
      state.activePortal = activePortal || "talent";
      state.roles = roles || [];
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const { loginUser, logoutUser, initializeAuth, setLoading } = authSlice.actions;

export default authSlice.reducer;
